import React from "react";
import "../GuestMode/GuestMode.scss";

interface ClubListSkeletonProps {
  rowCount?: number;
}

const ClubListSkeleton: React.FC<ClubListSkeletonProps> = ({ rowCount = 5 }) => {
  return (
    <div data-testid="make-offer-club-list-skeleton">
      {Array.from({ length: rowCount }, (_, index) => (
        <div className="clubCon" key={`make-offer-club-list-skeleton-${index}`}>
          <div className="form-check m-3 align-items-center col d-flex">
            <div
              className="loading-effect"
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "2px",
                marginRight: "12px",
              }}
            />
            <div
              className="loading-effect"
              style={{
                width: "50px",
                height: "35px",
                marginLeft: "10px",
                marginRight: "10px",
              }}
            />
            <div className="align-content-center col d-flex">
              <div className="yellowTxt col text-left">
                <div className="loading-effect loading-effect-text loading-effect-text-lg" />
                {index === 0 ? (
                  <div className="loading-effect loading-effect-text loading-effect-text-xs mt-1" />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ClubListSkeleton;
